// tslint:disable
export enum TCSCommunicationType {
    /**
     * @description None
     */
    None = 0,
    /**
     * @description Letter
     */
    Letter = 1,
    /**
     * @description Email
     */
    Email = 2,
    /**
     * @description SMS
     */
    SMS = 4,
    /**
     * @description Phone
     */
    Phone = 8,
    /**
     * @description Fax
     */
    Fax = 16,
}
(TCSCommunicationType as any)['NONE'] = 0;
(TCSCommunicationType as any)['LETTER'] = 1;
(TCSCommunicationType as any)['EMAIL'] = 2;
(TCSCommunicationType as any)['PHONE'] = 8;
(TCSCommunicationType as any)['FAX'] = 16;
